const CambodiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111069)">
      <path
        d="M0 19.9997C0 23.4645 0.881484 26.7234 2.4318 29.5649L20 31.3041L37.5682 29.5649C39.1185 26.7234 40 23.4645 40 19.9997C40 16.5348 39.1185 13.2759 37.5682 10.4345L20 8.69531L2.4318 10.4345C0.881484 13.2759 0 16.5348 0 19.9997H0Z"
        fill="#D80027"
      />
      <path
        d="M2.43164 10.4348H37.568C34.1759 4.21789 27.5807 0 19.9998 0C12.419 0 5.82375 4.21789 2.43164 10.4348Z"
        fill="#0052B4"
      />
      <path
        d="M19.9998 40.0002C27.5807 40.0002 34.1759 35.7823 37.568 29.5654H2.43164C5.82375 35.7823 12.419 40.0002 19.9998 40.0002Z"
        fill="#0052B4"
      />
      <path
        d="M26.9563 23.9128V21.3041H25.2172V17.8258L23.4781 16.0867L21.739 17.8258V14.3475L19.9998 12.6084L18.2607 14.3475V17.8258L16.5215 16.0867L14.7824 17.8258V21.3041H13.0433V23.9128H11.3042V26.5214H28.6954V23.9128H26.9563Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111069">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CambodiaSvg;
